import { useState } from "react";

export const useFeatureVisibility = (
  authorizedFeatures: string[],
  accessCodes: Record<string, string>,
  visibleMenuItems: string[],
) => {
  const isFeatureDisabled = (feature?: string): boolean => {
    if (!feature || !accessCodes[feature]) return false;
    return false;
  };

  const shouldShowEyeIcon = (feature?: string): boolean => {
    if (!feature || feature === "dashboard") return false;
    return authorizedFeatures.includes(feature);
  };

  const isFeatureVisible = (name: string, feature?: string): boolean => {
    // If it's the dashboard, always visible
    if (!feature || feature === "dashboard") return true;
    
    // If the feature is disabled, it's visible
    if (isFeatureDisabled(feature)) return true;
    
    // If the feature isn't in authorized features, it's visible
    if (!authorizedFeatures.includes(feature)) return true;
    
    // Check if tab masking is enabled for this feature
    const isTabMaskingEnabled = localStorage.getItem('tabMaskingEnabled') === 'true';
    
    // If tab masking is disabled, always show the feature
    if (!isTabMaskingEnabled) return true;
    
    // If the feature has an access code and is not in visible menu items, hide it
    if (accessCodes[feature] && !visibleMenuItems.includes(name)) {
      return false;
    }
    
    // Otherwise, show the feature
    return true;
  };

  return {
    isFeatureDisabled,
    shouldShowEyeIcon,
    isFeatureVisible,
  };
};
